/**
 * Pure helpers for AG Grid 29 SSRM + pagination.
 *
 * LazyStore can request blocks below the current pager page after sparse jumps
 * (e.g. Last → Previous). Do not purge the store on newPage — that resets
 * rowCount to the loading placeholder and snaps currentPage back to 0.
 *
 * Assumes the visible page is [currentPage * pageSize, (currentPage + 1) * pageSize).
 * Blocks that only partially overlap the page are allowed (cacheBlockSize may
 * differ from pageSize); only blocks entirely before the page are rejected.
 */

export function getCurrentPageRowRange(currentPage, pageSize) {
  if (currentPage == null || pageSize == null) return null;
  const page = Number(currentPage);
  const size = Number(pageSize);
  if (!Number.isFinite(page) || page < 0 || !Number.isFinite(size) || size <= 0) {
    return null;
  }
  const start = page * size;
  return { start, end: start + size };
}

/**
 * True when the requested block lies entirely before the pager's current page.
 * currentPage 0 never rejects (initial load / first page).
 */
export function isBlockEntirelyBeforeCurrentPage(
  startRow,
  endRow,
  currentPage,
  pageSize
) {
  if (currentPage == null || currentPage <= 0) return false;
  const range = getCurrentPageRowRange(currentPage, pageSize);
  if (!range) return false;
  const start = startRow != null ? Number(startRow) : 0;
  const end =
    endRow != null && Number(endRow) > start ? Number(endRow) : start;
  if (!Number.isFinite(start) || !Number.isFinite(end)) return false;
  return end <= range.start;
}



// WEBPACK FOOTER //
// ./src/components/grid/ssrmPaginationGuard.js